import { render, staticRenderFns } from "./handbooks.vue?vue&type=template&id=4afc6ff6&"
import script from "./handbooks.vue?vue&type=script&lang=js&"
export * from "./handbooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports